import { render, staticRenderFns } from "./ChannelSelection.html?vue&type=template&id=ab42242c&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSelection.scss?vue&type=style&index=0&id=ab42242c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab42242c",
  null
  
)

export default component.exports